import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { ConfigProvider } from './ConfigProvider/ConfigProvider';
const engine = new Styletron();
export const UiProvider = ({ children, tooltipProviderProps, ...config }) => (_jsx(ConfigProvider, { config: config, children: _jsx(RadixTooltip.Provider, { ...tooltipProviderProps, children: _jsx(StyletronProvider, { value: engine, children: children }) }) }));
